export default __webpack_public_path__ + "static/media/bg-transition-home.bcee9266.jpg";